import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({ name: 'bhTimeString' })
export class TimeStringPipe implements PipeTransform {
  transform(value: number, timestamp: string): string {
    const datePipe = new DatePipe('en-US');

    switch (timestamp) {
      case '1m':
      case '5m':
      case '30m':
      case 'hour':
        return datePipe.transform(value, 'HH:mm');
      case 'day':
      case 'week':
        return datePipe.transform(value, 'dd-MM');
      case '1M':
        return datePipe.transform(value, 'MM-yyyy');
      default:
        return '';
    }
  }
}

@Pipe({name: 'ymdDate'})
export class YMDDatePipe implements PipeTransform {
  transform(dateRaw= ''): any {
    if(!dateRaw.length) {
      return ''
    }
    const dateFormat = new Intl.DateTimeFormat('en-US').format(new Date(dateRaw));
    const [m, d, y] = dateFormat.split('/');
    return `${y}/${m}/${d}`;
  }
}
